import {createContext, useContext} from "react";

import IConfirmModalContextProps from "./interface";

export const ConfirmModalContext = createContext<IConfirmModalContextProps>({} as IConfirmModalContextProps);

export function useConfirmModal(): IConfirmModalContextProps{
	const context = useContext(ConfirmModalContext);

	if(!context){
		throw new Error("useConfirmModal function must be used inside the ConfirmModal Provider.");
	}

	return context;
}
